// Updated AvatarView.js with integrated toast and purechat support
import React from "react";
import { TrulienceAvatar } from "@trulience/react-sdk"
import { Toast } from "./Toast";
import { FullscreenButton } from "./IconButtons";

/**
 * Component to display the Trulience Avatar with integrated toast notifications
 */
export const AvatarView = ({
  isAppConnected,
  isConnectInitiated,
  isAvatarLoaded,
  loadProgress,
  trulienceConfig,
  trulienceAvatarRef,
  eventCallbacks,
  children,
  isFullscreen,
  toggleFullscreen,
  isKiosk = false,
  toast, // Add toast prop here
  isPureChatMode = false,
}) => {
  // In kiosk mode, clicking the avatar itself toggles fullscreen (the control
  // buttons are siblings of this div, so they don't trigger it).
  const avatarClickToggle = isKiosk && isAppConnected ? toggleFullscreen : undefined;
  return (
    <div
      className={`avatar-container ${isFullscreen ? "fullscreen" : ""} ${
        isKiosk ? "kiosk" : ""
      } ${isKiosk && isFullscreen ? "kiosk-fullscreen" : ""}`}
    >
      {/* Fullscreen toggle button - hidden when not connected, and hidden in
          kiosk mode (clicking the avatar toggles fullscreen instead) */}
      {isAppConnected && !isKiosk && (
        <FullscreenButton isFullscreen={isFullscreen} onClick={toggleFullscreen} />
      )}

      {/* Trulience Avatar - hidden when not connected or in purechat mode without connection */}
      <div
        className={`trulience-avatar ${(!isAppConnected || (isPureChatMode && !isAppConnected)) ? "hidden" : ""}`}
        onClick={avatarClickToggle}
      >
        <TrulienceAvatar
          key={trulienceConfig.avatarId}
          url={trulienceConfig.trulienceSDK}
          ref={trulienceAvatarRef}
          avatarId={trulienceConfig.avatarId}
          token={trulienceConfig.avatarToken}
          eventCallbacks={eventCallbacks}
          width="100%"
          height="100%"
          backgroundColor="transparent"
          autoConnect={false}
          envParams={{
            // Let the Trulience SDK fetch its own VBA Agora credentials and
            // subscribe to its VBA media server (matches the Trulience
            // reference client, which runs VBA avatars with useAgoraVideo:false).
            useAgoraVideo: false,
            // Optional override to point the SDK at a specific (test) media
            // server. Only sent when provided via ?controllerEndpoint=…
            ...(trulienceConfig.controllerEndpoint
              ? { controllerEndpoint: trulienceConfig.controllerEndpoint }
              : {}),
          }}
        />
      </div>

      {/* Loading overlay - only show if connected but avatar not loaded */}
      {isConnectInitiated && !isAvatarLoaded && !isPureChatMode && (
        <div className="loading-overlay">
          <div className="progress-bar">
            <div
              className="progress-indicator"
              style={{ width: `${loadProgress * 100}%` }}
            />
          </div>
        </div>
      )}

      {/* Render children (control buttons) — hidden in kiosk fullscreen */}
      {!(isKiosk && isFullscreen) && children}
      <div id="floating-input"></div>
    </div>
  );
};